import { Phone, MessageCircle, Mail, Clock3, Languages } from "lucide-react";
import { useLang } from "@/context";
import { CONTACT, waLink } from "@/i18n";
import { Reveal } from "./Reveal";

export const Contact = () => {
    const { t } = useLang();
    const cards = [
        {
            testid: "contact-card-phone",
            icon: Phone,
            title: t.contact.phone,
            content: (
                <div className="space-y-1">
                    <a data-testid="contact-phone-primary" href={`tel:${CONTACT.phone1}`} className="block font-semibold text-[#2A0505] hover:text-[#8D1717] transition-colors">{CONTACT.phone1}</a>
                    <a data-testid="contact-phone-alternate" href={`tel:${CONTACT.phone2}`} className="block font-semibold text-[#2A0505] hover:text-[#8D1717] transition-colors">{CONTACT.phone2}</a>
                </div>
            ),
        },
        {
            testid: "contact-card-whatsapp",
            icon: MessageCircle,
            title: t.contact.whatsapp,
            content: (
                <div className="space-y-1">
                    <a data-testid="contact-whatsapp-link" href={waLink()} target="_blank" rel="noreferrer" className="block font-semibold text-[#2A0505] hover:text-[#16A34A] transition-colors">{CONTACT.phone1}</a>
                    <a data-testid="contact-whatsapp-alternate" href={`tel:${CONTACT.phone2}`} className="block font-semibold text-[#2A0505] hover:text-[#8D1717] transition-colors">{CONTACT.phone2}</a>
                </div>
            ),
        },
        {
            testid: "contact-card-email",
            icon: Mail,
            title: t.contact.email,
            content: (
                <a data-testid="contact-email-link" href={`mailto:${CONTACT.email}`} className="font-semibold text-[#2A0505] hover:text-[#8D1717] transition-colors break-all">{CONTACT.email}</a>
            ),
        },
        {
            testid: "contact-card-hours",
            icon: Clock3,
            title: t.contact.hours,
            content: <span data-testid="contact-hours-value" className="font-semibold text-[#2A0505]">{t.contact.hoursValue}</span>,
        },
        {
            testid: "contact-card-languages",
            icon: Languages,
            title: t.contact.languages,
            content: <span data-testid="contact-languages-value" className="font-semibold text-[#2A0505]">{t.contact.languagesValue}</span>,
        },
    ];

    return (
        <section id="contact" data-testid="contact-section" className="py-20 sm:py-28 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <Reveal className="max-w-2xl">
                    <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#8D1717]">{t.nav.contact}</p>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#2A0505] mt-3">{t.contact.heading}</h2>
                    <p className="text-base sm:text-lg text-[#6B5B57] mt-4">{t.contact.sub}</p>
                </Reveal>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
                    {cards.map((card, i) => (
                        <Reveal key={card.testid} delay={i * 0.06}>
                            <div data-testid={card.testid} className="h-full rounded-3xl border border-[#EADFD8] bg-[#FBF7F3] p-7 hover:-translate-y-1.5 hover:shadow-xl transition-all duration-300">
                                <span className="w-11 h-11 rounded-2xl bg-[#8D1717]/10 flex items-center justify-center">
                                    <card.icon className="w-5 h-5 text-[#8D1717]" />
                                </span>
                                <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#a08b85] mt-4">{card.title}</p>
                                <div className="mt-1.5 text-base">{card.content}</div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
